import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import App from './App';
import './styles.css';

export const authConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY || 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_TuYAq7gB3',
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || '42m0lftgoms9389ju2q04hmboi',
  redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URI || `${window.location.origin}/`,
  response_type: 'code',
  scope: 'phone openid email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  onSigninCallback: () => window.history.replaceState({}, document.title, window.location.pathname),
};

createRoot(document.getElementById('root')).render(
  <React.StrictMode><AuthProvider {...authConfig}><App /></AuthProvider></React.StrictMode>
);
